export const THEME_SWATCHES = [
  '#6366F1',
  '#8B5CF6',
  '#EC4899',
  '#F43F5E',
  '#F97316',
  '#EAB308',
  '#22C55E',
  '#14B8A6',
  '#06B6D4',
  '#3B82F6',
];

type TzOption = { label: string; value: string; offset: number };

export const TIMEZONE_OPTIONS: TzOption[] = (() => {
  const now = new Date();
  const utcMs = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' })).getTime();
  return (Intl as unknown as { supportedValuesOf: (key: string) => string[] })
    .supportedValuesOf('timeZone')
    .map((tz: string): TzOption => {
      const localMs = new Date(now.toLocaleString('en-US', { timeZone: tz })).getTime();
      const diff = Math.round((localMs - utcMs) / 60000);
      const sign = diff >= 0 ? '+' : '-';
      const abs = Math.abs(diff);
      const h = String(Math.floor(abs / 60)).padStart(2, '0');
      const m = String(abs % 60).padStart(2, '0');
      return { label: `(UTC ${sign}${h}:${m}) ${tz}`, value: tz, offset: diff };
    })
    .sort((a: TzOption, b: TzOption) => a.offset - b.offset || a.value.localeCompare(b.value));
})();

export function getTimePreview(now: Date): { h24: string; h12: string } {
  return {
    h24: now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
    h12: now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }),
  };
}
